module.exports = __webpack_public_path__ + "static/chopard-12440981a52e037ad9ffd96bcd56281e.png";